module.exports = __webpack_public_path__ + "img/huji3.885fb2a2.png";